import { createStore } from "vuex";
import investorFlipProjects from "@/Investorflipstore";

export default createStore({
	state: {
		services: [
			{
				id: 1,
				title: 'Kitchen Remodeling',
				titleService: 'Kitchen Remodeling in Charlotte, NC',
				textService1: 'Custom kitchens designed around how you cook and gather - cabinetry, countertops, lighting and layout changes.',
				textService2: 'What\'s included: custom and semi-custom cabinetry, quartz and natural stone countertops, backsplash, lighting, appliance installation, and layout changes such as moving walls or adding an island.',
				textService3: 'Everything under one roof: demolition, flooring, drywall, electrical and plumbing are handled by the same team, so you never coordinate separate contractors.',
				textService4: 'Your price, set in writing: you approve a detailed price before any work begins.',
				textService5: 'Next step: a complimentary in-home design consultation.',
				details: {
					images: [
						{
							id: 13,
							src: ['/images/kitchen/kitchen-remodel-charlotte-124.jpg', '/images/kitchen/kitchen-remodel-charlotte-125.jpg', '/images/kitchen/kitchen-remodel-charlotte-117.jpg', '/images/kitchen/kitchen-remodel-charlotte-118.jpg', '/images/kitchen/kitchen-remodel-charlotte-119.jpg', '/images/kitchen/kitchen-remodel-charlotte-120.jpg', '/images/kitchen/kitchen-remodel-charlotte-121.jpg', '/images/kitchen/kitchen-remodel-charlotte-122.jpg', '/images/kitchen/kitchen-remodel-charlotte-123.jpg', '/images/kitchen/kitchen-remodel-charlotte-116.jpg'],
							year: '2026',
							title: 'Kitchen',
							description: 'Backsplash replacement. Installation of custom decorative elements, valances, and brackets for the cabinet above the stove. The cabinet legs were also custom-cut to the required shape. Additionally, the entire kitchen cornice was replaced. All kitchen cabinets were painted, and the walls and ceiling were repainted as well.',
							location: 'Charlotte, NC',
							duration: '14 days',
							review: ''
						},
						{
							id: 12,
							src: ['/images/kitchen/kitchen-remodel-charlotte-017.webp', '/images/kitchen/kitchen-remodel-charlotte-016.webp', '/images/kitchen/kitchen-remodel-charlotte-018.webp', '/images/kitchen/kitchen-remodel-charlotte-019.webp', '/images/kitchen/kitchen-remodel-charlotte-020.webp', '/images/kitchen/kitchen-remodel-charlotte-024.webp', '/images/kitchen/kitchen-remodel-charlotte-025.webp', '/images/kitchen/kitchen-remodel-charlotte-026.webp'],
							year: '2026',
							title: 'Kitchen',
							description: 'Installation of new cabinets to expand the kitchen space. Conversion of the kitchen island into a single-level unit and rewiring of the electrical system. Painting of all cabinets in a versatile beige shade (two coats of primer, three coats of paint). Fabrication and installation of "Ivory Quartz" countertops and backsplashes. Installation of new handles and other hardware.',
							location: 'Charlotte, NC',
							duration: '12 days',
							review: ''
						},
						{
							id: 11,
							src: ['/images/kitchen/kitchen-remodel-charlotte-110.webp', { youtubeId: 'MxYvlGD75w0' }, '/images/kitchen/kitchen-remodel-charlotte-115.webp', '/images/kitchen/kitchen-remodel-charlotte-112.webp', '/images/kitchen/kitchen-remodel-charlotte-111.webp', '/images/kitchen/kitchen-remodel-charlotte-114.webp'],
							year: '2026',
							title: 'Kitchen',
							description: 'We replaced the kitchen cabinets with new, more practical ones, replaced the countertops, added tile backsplashes, removed the textured tiles, repainted the entire room, installed a new sink and new appliances.',
							location: 'Charlotte, NC',
							duration: '14 days',
							review: '“From cost perspective K&M are bit on higher side, but am super glad assigned work to Vitalli and team. Ivan is great contractor and will hire him for any future projects down the line. Overall quality of work is top notch and team was very responsive with any concerns.” - Subramanya G.'
						},
						{
							id: 2,
							src: ['/images/kitchen/kitchen-remodel-charlotte-01.webp', { youtubeId: 'aeR8AcLSPqQ' }, '/images/kitchen/kitchen-remodel-charlotte-12.webp', '/images/kitchen/kitchen-remodel-charlotte-13.webp'],
							year: '2026',
							title: 'Kitchen',
							description: 'Removal of pantry, old cabinets, countertops, and backsplash. Widening of door and window openings. New lighting and electrical wiring. New cabinets, countertops, and backsplash. New floor tiles.',
							location: 'Weddington, NC',
							duration: '10 days',
							review: '“We recently completed a kitchen remodel and had a great experience from start to finish.The job involved expanding the doorway to the kitchen, replacing cabinets, floor, and countertops. The team was wonderful to work with, both during the design phase and throughout the hands-on construction. They listened to our ideas, offered helpful suggestions, and kept everything moving smoothly. The project was completed on time, which we really appreciated. While there were a few minor issues along the way, they went above and beyond to resolve them quickly and professionally. We’re very happy with the results and would absolutely recommend them to anyone needing home remodeling services.” - S M'
						},
						{
							id: 3,
							src: ['/images/kitchen/kitchen-remodel-charlotte-04.webp'],
							year: '2025',
							title: 'Kitchen',
							description: 'Complete kitchen installation with custom cabinets.',
							location: 'Charlotte, NC',
							duration: '12 days',
							review: '“I honestly didn\'t think my kitchen could look this good.” - Barbara B.'
						},
						{
							id: 4,
							src: ['/images/kitchen/kitchen-remodel-charlotte-06.webp', '/images/kitchen/kitchen-remodel-charlotte-063.webp', '/images/kitchen/kitchen-remodel-charlotte-061.webp', '/images/kitchen/kitchen-remodel-charlotte-062.webp'],
							year: '2025',
							title: 'Kitchen',
							description: 'Full kitchen renovation , cabinet installation, plumbing work.',
							location: 'Huntersville, NC',
							duration: '14 days',
							review: '“We\'re so happy with our kitchen remodel!” - Tira H.'
						},
						{
							id: 5,
							src: ['/images/kitchen/kitchen-remodel-charlotte-02.webp', '/images/kitchen/kitchen-remodel-charlotte-023.webp', '/images/kitchen/kitchen-remodel-charlotte-022.webp', '/images/kitchen/kitchen-remodel-charlotte-021.webp'],
							year: '2025',
							title: 'Kitchen',
							description: 'Installation of modern kitchen cabinets, sink, and faucet.',
							location: 'Concord, NC',
							duration: '10 days',
							review: '“Vitalii and his team were great to work with - professional” - Caleb E.'
						},
						{
							id: 6,
							src: ['/images/kitchen/kitchen-remodel-charlotte-03.webp', '/images/kitchen/kitchen-remodel-charlotte-031.webp', '/images/kitchen/kitchen-remodel-charlotte-032.webp', '/images/kitchen/kitchen-remodel-charlotte-033.webp'],
							year: '2025',
							title: 'Kitchen',
							description: 'Efficient kitchen installation focused on maximizing.',
							location: 'Ballantyne, NC',
							duration: '9 days',
							review: '“Vitalii was responsive and the kitchen turned out well.” - Hugo B.'
						},
						{
							id: 7,
							src: ['/images/kitchen/kitchen-remodel-charlotte-00.webp', '/images/kitchen/kitchen-remodel-charlotte-0.webp'],
							year: '2025',
							title: 'Kitchen',
							description: 'Custom cabinets, modern lighting.',
							location: 'Weddington, NC',
							duration: '11 days',
							review: '“Our kitchen looks great - bright and clean, just what we wanted.” - Mickey T.'
						},
						{
							id: 9,
							src: ['/images/kitchen/kitchen-remodel-charlotte-08.webp', '/images/kitchen/kitchen-remodel-charlotte-081.webp', '/images/kitchen/kitchen-remodel-charlotte-082.webp', '/images/kitchen/kitchen-remodel-charlotte-083.webp', '/images/kitchen/kitchen-remodel-charlotte-084.webp'],
							year: '2025',
							title: 'Kitchen',
							description: 'Complete kitchen installation from cabinets to final finishes.',
							location: 'Gastonia, NC',
							duration: '14 days',
							review: '“Happy with the work K&M did on our kitchen - looks good!” - Josh S.'
						}
					]
				}
			},
			{
				id: 2,
				title: 'Bathroom Remodeling',
				titleService: 'Bathroom Remodeling in Charlotte, NC',
				textService1: 'Spa-like bathrooms with walk-in showers, custom vanities and tile work, fully waterproofed and built to last.',
				textService2: 'What\'s included: walk-in and frameless glass showers, freestanding and soaking tubs, custom vanities, tile floors and walls, lighting and fixtures.',
				textService3: 'Built to last: every shower is fully waterproofed behind the tile, the part of a bathroom you never see but that matters most.',
				textService4: 'Everything under one roof: demolition, plumbing, electrical, flooring and drywall handled by one team.',
				textService5: 'Next step: a complimentary in-home design consultation.',
				details: {
					images: [
						// {
						// 	id: 1001,
						// 	src: ['/images/bathroom/bathroom-renovation-contractor-1.webp'],
						// 	year: '2025',
						// 	title: 'Bathroom',
						// 	description: 'Complete bathroom renovation with walk-in shower, modern tile, new vanity, and updated lighting.',
						// 	location: 'Charlotte, NC',
						// 	duration: '10 days',
						// 	review: '“Very professional work and great attention to detail. The bathroom looks amazing.” - Michael R.'
						// },
						// {
						// 	id: 1004,
						// 	src: ['/images/bathroom/bathroom-renovation-contractor-4.webp'],
						// 	year: '2025',
						// 	title: 'Bathroom',
						// 	description: 'Durable and practical bathroom remodel designed for everyday family use.',
						// 	location: 'Mooresville, NC',
						// 	duration: '12 days',
						// 	review: '“Perfect for our family. Everything was done quickly and professionally.” - Jason L.'
						// }
					]
				}
			},
			{
				id: 3,
				title: 'Home Remodeling',
				titleService: 'Full Home Remodeling in Charlotte, NC',
				textService1: 'Open up your floor plan and update every room at once, with one team managing design, permits and construction.',
				textService2: 'What\'s included: open-concept layouts and wall removal, kitchens and bathrooms, flooring, painting, trim, lighting and electrical updates throughout the home.',
				textService3: 'One team, one plan: a single project manager coordinates every trade and every phase, so the whole home comes together as one design.',
				textService4: 'Permits and inspections handled: including structural and load-bearing changes.',
				textService5: 'Your price, set in writing: every phase is priced and approved before work begins.',
				textService6: 'Next step: a complimentary in-home design consultation.',
				details: {
					images: [
						{
							id: 2005,
							src: ['/flip/monro/monro_08.jpg',{ youtubeId: '3k9gEM1xIog' },  '/flip/monro/monro_05.jpg', '/flip/monro/monro_06.jpg', '/flip/monro/monro_07.jpg', '/flip/monro/monro_09.jpg', '/flip/monro/monro_010.jpg', '/flip/monro/monro_011.jpg'],
							year: '2026',
							title: 'Full Home, Kitchen, Dining & Living Room, Wiring, Painting',
							description: 'Scope of work: Wall removal for an open-concept layout. Full electrical redesign across the entire area. Plumbing relocation for the refrigerator, sink, and coffee bar. Custom cabinetry with a built-in coffee bar. Calacatta Zurich quartz countertops and matching backsplash. New flooring throughout the 1,600 sq ft first floor. Drywall and paint',
							location: 'Monroe, NC',
							duration: '5 weeks',
							review: '“K&M are an amazing group of professionals from meeting Vitalii and creating the original plans and estimate, selecting cabinets, counter tops and flooring! When we made a few changes in the plan Vitalii immediately updated the 3D model of the kitchen! The demolition crew, Alex and Ivan were fast, neat and respectful of us still being in the home! Their timing with contractors was impeccable! One would finish and the next would be there within the hour! We were told this project would take 4-6 weeks and week 5 everything was wrapping up! Shout out to Ivan, Dan, Alex, Mike, Mark, Olec, Miguel and the paint crew. This may be a relatively new company but they are top notch and pay close attention to detail!”- Martha McCraw'
						},
						{
							id: 2001,
							src: ['/flip/kilcullen/after-exterior-01.jpg', { youtubeId: 'kz4-cBaCEy4' }, '/flip/kilcullen/after-exterior-02.jpg', '/flip/kilcullen/after-exterior-04.jpg', '/flip/kilcullen/after-exterior-05.jpg', '/flip/kilcullen/after-kitchen-01.jpg', '/flip/kilcullen/after-kitchen-02.jpg', '/flip/kilcullen/after-living-01.jpg', '/flip/kilcullen/after-living-02.jpg', '/flip/kilcullen/after-living-03.jpg'],
							year: '2026',
							title: 'Full Home, Kitchen, Bathroom',
							description: 'Beautifully and meticulously renovated 4-bedroom, 3-bathroom home tucked away on a quiet cul-de-sac in desirable South Charlotte — within walking distance of the 19-mile Little Sugar Creek Greenway. New flooring throughout, fresh paint, renovated bathrooms, recessed lighting, and a stunning remodeled kitchen with Taj Mahal Quartz countertops, white cabinetry, and brass hardware.',
							location: 'Charlotte, NC',
							duration: '8 weeks',
							review: ''
						},
						{
							id: 2002,
							src: ['/images/kitchen/kitchen-remodel-charlotte-011.jpg', '/images/kitchen/kitchen-remodel-charlotte-001.jpg', '/images/kitchen/kitchen-remodel-charlotte-002.jpg', '/images/kitchen/kitchen-remodel-charlotte-003.jpg', '/images/kitchen/kitchen-remodel-charlotte-012.jpg', '/images/kitchen/kitchen-remodel-charlotte-013.jpg', '/images/kitchen/kitchen-remodel-charlotte-014.jpg', '/images/kitchen/kitchen-remodel-charlotte-015.jpg'],
							year: '2026',
							title: 'Kitchen, Wiring, Painting',
							description: 'Removal of old countertops, cabinets, and the kitchen backsplash. Modification of the kitchen island to create a seamless, single-level surface; relocation of electrical wiring. Installation of new cabinets featuring soft-close hardware: grey fronts for base cabinets, and white fronts for wall and overhead (upper-tier) cabinets. Dallas White granite countertops. White subway tile. Custom-made bench for the dining area. Painting of walls, ceilings, and trim throughout the ground floor.',
							location: 'Charlotte, NC',
							duration: '14 days',
							review: '“We cannot say enough amazing things about our kitchen remodel experience! From start to finish, this company exceeded our expectations. We are absolutely obsessed with our new kitchen and the quality of work they provided. The communication throughout the entire process was incredible. They were responsive, professional, and kept us updated every step of the way. Their attention to detail was truly unmatched — they cared about the little things and made sure everything was done perfectly. They went above and beyond by creating a custom bench and adding personal touches that made the experience feel so special. It was clear that they take pride in their work and genuinely care about their customers. The craftsmanship, professionalism, and dedication they brought to our project were outstanding. We would recommend them to anyone looking for a remodel team that delivers beautiful results and an amazing experience. Thank you for making our dream kitchen a reality!”- Maggie'
						},
						{
							id: 2003,
							src: ['/images/kitchen/kitchen-remodel-charlotte-101.webp', { youtubeId: '_fPtBrgrPfs' }, { youtubeId: 'waF-FlODNLM' }, '/images/kitchen/kitchen-remodel-charlotte-102.webp', '/images/kitchen/kitchen-remodel-charlotte-103.webp', '/images/kitchen/kitchen-remodel-charlotte-104.webp'],
							year: '2026',
							title: 'Kitchen, Flooring, Painting',
							description: 'Complete remodeling, including replacing kitchen cabinets, countertops, and backsplashes, completely replacing flooring, repainting walls and ceilings, and installing a vent from the range hood (previously, it was filtered). Notable details: 1) 6-inch wide pull-out spice drawer (custom-made) 2) Wall-mounted cabinet with two drawers underneath, one on the countertop 3) Finishing and outfitting the pantry with drawers and shelves 4) Installing a pull-out drawer in a cabinet with a blind corner to save space',
							location: 'Ballantyne, NC',
							duration: '14 days',
							review: '“A huge thank you to Ivan and his wonderful team! They completely transformed my kitchen, redesigning the space so I can use it much more efficiently. The quality of the work is excellent, and they kept everything clean and tidy throughout the entire process. Now I feel like I\'m in a brand new home!” - Rick C.'
						},
						{
							id: 2004,
							src: ['/images/kitchen/kitchen-remodel-charlotte-05.webp', { youtubeId: 'euZYqYe8A6Y' }, '/images/kitchen/kitchen-remodel-charlotte-051.webp', '/images/kitchen/kitchen-remodel-charlotte-052.webp', '/images/kitchen/kitchen-remodel-charlotte-057.webp'],
							year: '2026',
							title: 'Kitchen, Wiring, Painting, Flooring',
							description: 'This project involved a full kitchen remodel, including the replacement of cabinets, countertops, and backsplash, along with the design of a new, highly functional layout to improve comfort and workflow.',
							location: 'Huntersville, NC',
							duration: '8 days',
							review: '“I didn\'t expect such a result. I\'m thrilled. I\'m amazed at the attention to detail. I thought I\'d have to worry about everything, but as I got going, I realized the guys had already thought of everything.” - Mike C.'
						}
					]
				}
			},
			{
				id: 4,
				title: 'Window and Door Replacement',
				titleService: 'Window and Door Replacement in Charlotte, NC',
				textService1: 'Professional installation of windows and doors for homes and renovations.',
				textService2: 'We replace old units, ensure proper insulation, sealing, and alignment.',
				textService3: 'Our team focuses on energy efficiency, security, and precise installation.',
				textService4: 'Clean work, clear pricing, and on-time completion. Typical timeline: 1–3 days.',
				textService5: 'Free on-site estimate.',
				details: {
					images: [
						// {
						// 	id: 3001,
						// 	src: ['/images/doors/doors-windows-installation-00.webp'],
						// 	year: '2025',
						// 	title: 'Windows & Doors',
						// 	description: 'Replacement of old windows and door with energy-efficient modern units for better insulation and comfort.',
						// 	location: 'Charlotte, NC',
						// 	duration: '2 days',
						// 	review: '“The new windows and door have made a noticeable difference in our energy bills.” - Robert H.'
						// },
						// {
						// 	id: 3002,
						// 	src: ['/images/doors/doors-windows-installation-05.webp'],
						// 	year: '2025',
						// 	title: 'Window and Door Remodeling',
						// 	description: 'Combined replacement of windows and doors to improve energy efficiency and curb appeal',
						// 	location: 'Monroe, NC',
						// 	duration: '3 days',
						// 	review: '“The team was professional and efficient. Our home looks fantastic with the new windows and doors.” - Steven P.'
						// },
						// {
						// 	id: 3003,
						// 	src: ['/images/doors/doors-windows-installation-07.webp'],
						// 	year: '2025',
						// 	title: 'Window & Door Upgrade',
						// 	description: 'Replacement of windows and doors to enhance comfort, security, and overall appearance.',
						// 	location: 'Charlotte, NC',
						// 	duration: '3 days',
						// 	review: '“Ivan and his team provided excellent service and quality installation.” - Karen W.'
						// },
						// {
						// 	id: 3004,
						// 	src: ['/images/doors/doors-windows-installation-030.webp'],
						// 	year: '2025',
						// 	title: 'Windows & Doors',
						// 	description: 'Complete replacement of windows and doors throughout the house with modern, energy-saving models.',
						// 	location: 'Davidson, NC',
						// 	duration: '3 days',
						// 	review: '“K&M Remodeling did an excellent job replacing our windows and doors. Highly recommend!” - Linda M.'
						// },
						// {
						// 	id: 3005,
						// 	src: ['/images/doors/doors-windows-installation-040.webp'],
						// 	year: '2025',
						// 	title: 'Windows & Doors',
						// 	description: 'Full replacement of windows and doors with modern, energy-efficient solutions.',
						// 	location: 'Charlotte, NC',
						// 	duration: '4 days',
						// 	review: '“The team was professional and efficient.” - Steven P.'
						// }
						// {
						// 	id: 3006,
						// 	src: ['/images/doors/doors-windows-installation-06.webp'],
						// 	year: '2025',
						// 	title: 'Energy-Efficient Window Installation',
						// 	description: 'Installation of modern energy-efficient windows to improve insulation and reduce energy costs.',
						// 	location: 'Pineville, NC',
						// 	duration: '2 days',
						// 	review: '“The rooms feel warmer and quieter. Great quality work.” - Brian N.'
						// }
					]
				}
			}

		],
		investorFlipProjects: investorFlipProjects,
		// Фото для превью на главной — меняйте как хотите
		// serviceId: 1=Kitchen, 2=Bathroom, 3=Full Home, 4=Window&Door
		// imageId: id конкретного фото внутри сервиса
		homepagePreview: [
			{ serviceId: 3, imageId: 2005 },
			{ serviceId: 1, imageId: 13 },
			{ serviceId: 3, imageId: 2001 }, 
		],
		portfolioFeatured: [
			{ serviceId: 3, imageId: 2005 },
			{ serviceId: 3, imageId: 2002 }, 
			{ serviceId: 1, imageId: 12 },  
			{ serviceId: 3, imageId: 2001 },  
			{ serviceId: 1, imageId: 6 },  
			{ serviceId: 1, imageId: 13 },  
		],
	},
	getters: {
		getServices: (state) => state.services,
		getInvestorFlipProjects: (state) => state.investorFlipProjects,
		getHomepagePreview: (state) => {
			return state.homepagePreview.map(({ serviceId, imageId }) => {
				const service = state.services.find(s => s.id === serviceId)
				if (!service) return null
				const image = service.details.images.find(img => img.id === imageId)
				if (!image) return null
				return { ...image, serviceTitle: service.title }
			}).filter(Boolean)
		},
		getPortfolioFeatured: (state) => {
			return state.portfolioFeatured.map(({ serviceId, imageId }) => {
				const service = state.services.find(s => s.id === serviceId)
				if (!service) return null
				const image = service.details.images.find(img => img.id === imageId)
				if (!image) return null
				return { ...image, serviceId: service.id, serviceTitle: service.title }
			}).filter(Boolean)
		},
	},
	mutations: {

	},
	actions: {

	},
	modules: {},
});